/**
 * Created by bootdo.
 */
import axios from 'axios'
import qs from 'qs'; 
import Vue from 'vue'
axios.defaults.withCredentials = true;
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';//配置请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
 
//基地址
/**
 * 请求拦截
 */
axios.interceptors.request.use(config => { 
//   config.headers['token'] = Vue.cookie.get('token') // 请求头带上token
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
axios.interceptors.response.use(response => {
//   if (response.data && response.data.code === 401) { // 401, token失效
//     clearLoginInfo()
//     router.push({ name: 'login' })
//   }
  return response
}, error => {
  return Promise.reject(error)
}) 
 let base = 'https://jinligao.dianguag.com' 

//通用方法 
export const POST = (url, params) => {
return axios.post(`${base}${url}`, qs.stringify(params),{headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then(res => res.data)
}
export const POSTJSON = (url, params) => {
  return axios.post(`${base}${url}`, qs.stringify(params),{headers: {'Content-Type': 'application/json'}}).then(res => res.data)
} 
export const GET = (url, params) => {
  return axios.get(`${base}${url}`,params).then(res => res.data)
}
export const PUT = (url, params) => {  
  return axios.put(`${base}${url}`, params,{headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }}).then(res => res.data)
}
export const DELETE = (url, params) => {
  return axios.delete(`${base}${url}`, {
    params: params
  }).then(res => res.data)
}
export const PATCH = (url, params) => {
  return axios.patch(`${base}${url}`, params).then(res => res.data)
}


// WEBPACK FOOTER //
// ./src/components/api/index.js